module.exports = __webpack_public_path__ + "img/point-up-left-with-bg.4825b27d.svg";